﻿

window.gro = window.gro || {};
gro.modules = gro.modules || {};

gro.modules.internalNavigation = (function () {
    var priv = {};

    priv.closeAllMenuItems = function () {
        $(".is-expanded").removeClass("is-expanded");
    };

    priv.closeSiblingMenuItems = function (menuItem, callback) {
        var parentLi = $(menuItem).closest("li");
        var parentUl = parentLi.parent();
        var openSiblings = parentUl.find("> li > .js-internal-navigation-category.is-expanded").not(menuItem);

        if (openSiblings.length === 0) {
            if (callback) callback();
            return;
        }

        var pending = openSiblings.length;
        openSiblings.each(function() {
            var target = $(this).next(".internal-navigation__list--sub-level");
            $(this).removeClass("is-expanded");
            $(target).slideUp("fast", function () {
                $(target).removeClass("is-expanded").removeAttr("style");
                pending--;
                if (pending === 0 && callback) callback();
            });
        });
    };

    priv.toggleMenuItem = function (menuItem, currentlyOpen) {
        var target = $(menuItem).next(".internal-navigation__list--sub-level");

        if (currentlyOpen) {
            $(target).slideUp("fast",
                function () {
                    $(menuItem).removeClass("is-expanded");
                    $(target)
                        .removeClass("is-expanded")
                        .removeAttr("style");
            });
        } else {
            $(menuItem).addClass("is-expanded");
            $(target).slideDown(250, "swing", function () {
                $(target)
                    .addClass("is-expanded")
                    .removeAttr("style");
            });
        }
    };

    priv.toggleMobileNavigation = function() {
        $(".internal-navigation__list").slideToggle();
    };

    priv.init = function () {
        $(".js-internal-navigation-category").on("click", function (e) {
            e.preventDefault();
            var self = this;
            var currentlyOpen = $(self).hasClass("is-expanded");
            priv.closeSiblingMenuItems(self, function () {
                priv.toggleMenuItem(self, currentlyOpen);
            });
        });

        $(".toggle-menu").click(function () {
            priv.toggleMobileNavigation();
        });
    };

    $(function () {
        priv.init();
    });

})();
